import React from 'react';
import { TextInputProps, TextInput } from './TextInput';
import { ControlledTextInput } from './ControlledTextInput';
import { stringWithLineBreak } from '../../utils/helpers';

export interface ITextInputForPrintProps extends TextInputProps {
  isControlledInput?: boolean;
}

export class TextInputForPrint extends React.PureComponent<ITextInputForPrintProps> {
  static defaultProps = {
    isControlledInput: false
  }
  
  public render() {
    return (
        <React.Fragment>
            <div className="only-print hide-sibling-in-print" aria-hidden={true} dangerouslySetInnerHTML={{ __html: stringWithLineBreak(this.props.value) }}>

        </div>
        {this.props.isControlledInput ? 
          <ControlledTextInput {...this.props} /> :
          <TextInput {...this.props} />}
      </React.Fragment>
    );
  }
}
